import { NSARouterMakerResult } from "namirasoft-account-react";
import { NotificationSenderLayout } from '../NotificationSenderLayout';
import { NotificationSenderEntity } from '../NotificationSenderEntity';
import { NotificationSenderProps } from '../NotificationSenderProps';

interface SubscriberViewPageProps extends NSARouterMakerResult, NotificationSenderProps
{ }

export default function SubscriberViewPage(props: SubscriberViewPageProps) 
{
    return (
        <NotificationSenderLayout
            {...props}
            action={{
                description: "This section displays detailed information about a selected subscriber, including contact details and subscribed topics."
            }}
            pages={{
                entity: NotificationSenderEntity.Subscriber(props),
                view: {}
            }}
        >
            <></>
        </NotificationSenderLayout >
    );
};